<template>
  <div>
    <!-- Pay All-->
    <a-modal v-model="visible" title="Pay all unpaid student fees (School)" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 720"
      :destroyOnClose="true"
      style="top: 20px;"
    >
      <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary"
            :loading="loading"
            @click="handlePay"
            v-if="feesToPay.length"
          >
            Pay Fee
          </a-button>
      </template>
      <a-spin :spinning="spinning">
        <div v-if="studentFeesData">
          <div v-if="feesToPay.length">
            <p class="font-weight-bold mb-2 text-muted">Fee details:</p>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Fee</th>
                  <th>Amount</th>
                  <th>Fine</th>
                  <th>Dis.</th>
                  <th>Dis. %</th>
                  <th>Due</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="fee in feesToPay" :key="fee.id">
                  <th>
                    {{fee.fee_setting.class_fee ? fee.fee_setting.class_fee.fee.name : fee.fee_setting.fee.name}}
                    <span
                      v-html='formatDescription(fee.fee_setting.class_fee ? fee.fee_setting.class_fee.fee.description : fee.fee_setting.fee.description)'
                      style='font-size: 12px; font-weight: 300; font-style: italic; display: block; margin-top: 4px;'
                    ></span>
                  </th>
                  <td>₹ {{fee.amount}}</td>
                  <td>₹ {{fee.fine ? fee.fine : 0}}</td>
                  <td>₹ {{fee.discount_amount ? fee.discount_amount : 0}}</td>
                  <td>{{fee.discount_percentage ? fee.discount_percentage : 0}}%</td>
                  <td>₹ {{fee.due_amount}}</td>
                  <td>₹ {{fee.fee_total}}</td>
                  <td>
                    <a href="javascript:;" class="text-danger py-1" @click="handleRemoveFee(fee.id)">
                      <i class="fe fe-x-square"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr class="mt-2 mb-4">

            <a-form class="mb-0" :form="form" @submit="handlePay">
              <div class="row mb-0">
                <div class="col-md-4 mb-2">
                  <a-form-item class="mb-0" label="Fine Amount">
                    <div style="width:120px;">
                      <a-input-number
                        placeholder="Fine"
                        v-decorator="[`fine`, {rules: [{ required: false, message: 'Please input fine amount!' }]}]"
                        :min="0"
                        :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                        style="width:100%;"
                        @change="handleFeeInputChange"
                      />
                    </div>
                  </a-form-item>
                </div>
                <div class="col-md-4 mb-2">
                  <a-form-item label="Discount Type">
                    <a-select style="width: 150px" v-model="discountType">
                      <a-select-option value="amount">Amount</a-select-option>
                      <a-select-option value="percentage">Percentage</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
                <div class="col-md-4 mb-2" v-if="discountType === 'amount'">
                  <a-form-item class="mb-0" label="Discount Amount">
                    <div style="width:120px;">
                      <a-input-number
                        placeholder="Discount amount"
                        v-decorator="[`discount_amount`, {rules: [{ required: false, message: 'Please input discount amount!' }]}]"
                        :min="0"
                        :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                        style="width:100%;"
                        @change="handleFeeInputChange"
                      />
                    </div>
                  </a-form-item>
                </div>
                <div class="col-md-4 mb-2" v-if="discountType === 'percentage'">
                  <a-form-item class="mb-0" label="Discount %">
                    <div style="width:120px;">
                      <a-input-number
                        placeholder="Discount %"
                        v-decorator="[`discount_percentage`, {rules: [{ required: false, message: 'Please input discount %!' }]}]"
                        :min="0"
                        :max="100"
                        :formatter="value => `${value}%`"
                        :parser="value => value.replace(/\%\s?|(,*)/g, '')"
                        style="width:100%;"
                        @change="handleFeeInputChange"
                      />
                    </div>
                  </a-form-item>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <a-form-item class="mb-0" label="Paid Amount">
                        <div style="width:150px;">
                          <a-input-number
                            placeholder="Amount"
                            v-decorator="[`paid_amount`, {rules: [{ required: true, message: 'Please input an amount!' }], initialValue: getPayableFee(
                              feeTotal,
                              form.getFieldValue('fine'),
                              form.getFieldValue('discount_amount'),
                              form.getFieldValue('discount_percentage')
                            )}]"
                            :min="0"
                            :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                            style="width:100%;"
                            :disabled="true"
                          />
                        </div>
                      </a-form-item>
                    </div>
                    <!-- Payable fee -->
                    <div class="col-4 col-sm-6 mt-2">
                      <p class="mt-4 mb-0 font-weight-bold text-danger" v-if="feeTotal && discountType">
                        / ₹{{getPayableFee(
                          feeTotal,
                          form.getFieldValue('fine'),
                          form.getFieldValue('discount_amount'),
                          form.getFieldValue('discount_percentage'),
                          )}}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <a-form-item
                    label="Payment Mode"
                  >
                    <a-select
                      v-decorator="[
                        'payment_type',
                        {rules: [{ required: true, message: 'Please select a payment type!!' }],
                        initialValue: 0 }
                      ]"
                      placeholder="Select payment type"
                    >
                      <a-select-option v-for="paymentType in paymentTypes" :value="paymentType.value" :key="paymentType.value">
                      {{paymentType.name}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
                <div class="col-md-6 mb-2">
                  <a-form-item label="Paid by">
                    <a-input
                      placeholder="Full Name"
                      v-decorator="['paid_by', {rules: [{ required: true, message: 'Please input a name!' }]}]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-6 mb-2">
                  <a-form-item
                    label="Payment Date"
                  >
                  <a-date-picker
                    @change="handlePaymentDateChange"
                    v-decorator="[
                    'payment_date',
                    {rules: [{ required: true, message: 'Please input a date' }], initialValue: moment()},
                    ]"
                    :format=dateFormat />
                  </a-form-item>
                </div>
                <div class="col-md-12 mb-2">
                  <a-form-item label="Remark">
                    <a-input
                      placeholder="Payment remark"
                      v-decorator="['remark', {rules: [{ required: false, message: 'Please input a remark!' }]}]"
                    />
                  </a-form-item>
                </div>
              </div>
            </a-form>
          </div>
          <div v-else>
            <p class="py-4">No Fees to be paid!</p>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import { paymentTypes } from '@/services/globaldata'

export default {
  name: 'PayAllStudentFees',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      classFees: null,
      feesLoading: false,
      studentFeesData: null,
      paymentTypes,
      discountType: 'amount',
      updatePayable: false,
      feesToPay: [],
      feeTotal: 0,
      feeAmtTotal: 0, // To store total of student fee amount without fine and discounts
      studentId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openPayAllStudentFeesModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  watch: {
    feesToPay: function (val) {
      let total = 0
      let amtTotal = 0
      val.forEach(element => {
        total = total + element.fee_total
        amtTotal = amtTotal + element.amount
      })
      this.feeTotal = total
      this.feeAmtTotal = amtTotal
    },
    updatePayable: function(val) {
      this.form.setFieldsValue({
        paid_amount: this.getPayableFee(
          this.feeTotal,
          this.form.getFieldValue('fine'),
          this.form.getFieldValue('discount_amount'),
          this.form.getFieldValue('discount_percentage')
        ),
      })
    },
    discountType: function(val) {
      this.handleFeeInputChange()
    },
  },
  methods: {
    moment,
    showModal: function(enrollment) {
      this.studentId = enrollment.student_id
      let studentFees = enrollment.student_fees
      this.studentFeesData = studentFees
      this.visible = true

      this.feesToPay = this.getUnpaidFees(this.studentFeesData)
    },
    handleFeeInputChange(value) {
      this.updatePayable = !this.updatePayable
    },
    handlePay: function (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the Pay button to pay the selected fees!`,
            okText: 'Pay',
            onOk: () => {
              const formData = this.makeEditFormData(values)
              this.$http
                .post('/api/student_fee/pay_all', formData)
                .then(({ data }) => {
                  this.$emit('paid')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully paid',
                    description: `Student fees paid successfully!`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    makeFeeData: function(studentFee) {
      const fieldData = {
        fine: studentFee.fine,
        discount_amount: studentFee.discount_amount,
        discount_percentage: studentFee.discount_percentage,
      }
      return fieldData
    },
    makeEditFormData(values) {
      const studentFees = this.feesToPay.map(element => {
        return element.id
      })
      let data = {
        payment_date: moment(values.payment_date).format('YYYY-MM-DD'),
        paid_by: values.paid_by,
        remark: values.remark,
        fine: values.fine ? values.fine : 0,
        payment_type: values.payment_type,
        paid_amount: values.paid_amount,
        student_fees: studentFees,
        student_id: this.studentId,
        is_paid_by_school: 1,
      }

      if (this.discountType === 'amount') {
        data.discount_amount = values.discount_amount ? values.discount_amount : 0
        data.discount_percentage = 0
      }
      if (this.discountType === 'percentage') {
        data.discount_amount = 0
        data.discount_percentage = values.discount_percentage ? values.discount_percentage : 0
      }
      return data
    },
    getUnpaidFees(fees) {
      const unPaidFees = fees.filter(element => element.payment_status !== 1)
      return unPaidFees
    },
    handleRemoveFee(feeId) {
      this.feesToPay = this.feesToPay.filter(element => element.id !== feeId)
      this.updatePayable = !this.updatePayable
    },
    formatDescription(description) {
      if (!description) return ''
      return description.replace(/\n/g, '<br>')
    },
    getPayableFee(dueAmount, fine, discountAmount, discountPercentage) {
      console.log('dueAmount:: ', dueAmount)
      console.log('feeAmtTotal:: ', this.feeAmtTotal)
      let discount = 0
      if (this.discountType === 'amount') {
        discount = discountAmount || 0
      }
      if (this.discountType === 'percentage') {
        discount = this.feeAmtTotal * (discountPercentage * 0.01) || 0
      }

      fine = fine || 0
      return (dueAmount + fine - discount).toFixed(2)
    },
    handlePaymentDateChange: function (value) {
      this.loading = true
      this.spinning = true
      let oldStudentFeesData = this.studentFeesData
      const oldStudentFeeIds = oldStudentFeesData
        .filter(oldStudentFee => oldStudentFee.payment_status !== 1)
        .map(oldStudentFee => oldStudentFee.id)
      this.$http
        .get('/api/student_fee_calculated', {
          params: {
            payment_date: moment(value).format('YYYY-MM-DD'),
            student_fee_ids: oldStudentFeeIds,
            is_paid_by_school: 1,
          },
        })
        .then(({ data }) => {
          // this.form.setFieldsValue('')
          this.studentFeesData = data.student_fees
          this.feesToPay = this.getUnpaidFees(this.studentFeesData)
          this.handleFeeInputChange()
          this.loading = false
          this.spinning = false
        })
        .catch(error => {
          this.spinning = false
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
  },
}
</script>
